<ng-container *ngIf="!finished">
    <div id="loading-js" *ngIf="isLoading" class="loading-js">
        <div class="loader">
            <img class="" src="./assets/img/loader.svg" width="60" alt="">
        </div>
    </div>
    <div class="stepline"></div>
    <mat-horizontal-stepper animationDuration="0ms" [@.disabled]="true" labelPosition="bottom" #stepper="matHorizontalStepper" class="row simyo-steppper"
                            [class.simyo-stepper-guard-mobile-rates]="shouldGuardClienteConfirmacionStepHeaders()"
                            [linear]="true" [disableRipple]="true" (selectionChange)="onStepChange($event)">
        <ng-template matStepperIcon="edit" let-index="index">{{index + 1}}</ng-template>
        <app-simyo-modal-save></app-simyo-modal-save>
        <mat-step [stepControl]="validateStep()" label="Fibra" state="number"
                  [editable]="isEditable"
                  *ngIf="typeOrder === orderType.CONVERGENT || typeOrder === orderType.BROADBAND">
            <div class="container content">
                <div class="row d-flex justify-content-center">
                    <div [class]="typeOrder !== orderType.MOBILE && +customerFormGroup.get('customer_doctype')?.value === 3 ? 'col-md-10' : 'col-md-8'">
                        <h5 class="title-step text-center" >
                            <img src="./assets/img/map-pin.svg" class="img-fluid ico-title" width="20">
                            Dirección de instalación
                        </h5>

                        <div *ngIf="!enviroment.production && muestraNormalizacion" (click)="setAddress(selectedTechnology)" class="btn btn-simyo-o2 d-block w-100 mb-1 default-address">
                            <span class="me-2">Dirección por defecto</span>
                            <select class="col-3 me-2" (click)="$event.stopPropagation()" [(ngModel)]="selectedTechnology">
                                <option *ngFor="let technology of arrayTechnologyTypes" [value]="technology">
                                    {{technology}}
                                </option>
                            </select>
                            <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
                        </div>
                        <div class="jumbotron-norm" style="margin-bottom: 4rem!important;" [hidden]="!muestraNormalizacion">
                            <app-simyo-normaliza-direccion *ngIf="!enableMyAddress" [formGroup]="normalizadorFormGroup"></app-simyo-normaliza-direccion>
                            <app-simyo-my-address *ngIf="enableMyAddress && showMyAddress" (addressSelected)="myAddressSelected($event)" (backToFastSearch)="backToFastSearch($event)"></app-simyo-my-address>
                            <app-simyo-cobertura [retryCoverageEvents]="retryCoverageSubject.asObservable()" [formGroup]="coberturaFormGroup" [address]="myAddressResponse"></app-simyo-cobertura>
                        </div>

                        <div *ngIf="!muestraNormalizacion">
                            <app-resultado class="simyo"></app-resultado>
                            <div id="Errores_ninguna" *ngIf="muestraErrorPeticion">
                                <!-- DF-498: sin cobertura (false) → modal WiFi 5G; no duplicar mensaje inline -->
                                <!--
                                <div *ngIf="thereIsCoverage === false && !permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas)">
                                    <ng-container *ngTemplateOutlet="errorSimyo"></ng-container>
                                </div>
                                -->
                                <!-- Error al solicitar cobertura Simyo (reintento) -->
                                <div *ngIf="thereIsCoverage === null">
                                    <ng-container *ngTemplateOutlet="errorSimyo"></ng-container>
                                </div>
                                <!-- DF-498: CTA Jazztel comentado a la espera de reconfirmación PVR (no eliminar aún) -->
                                <!--
                                <div *ngIf="thereIsCoverage === false && permSv.hasPermFromV2(allPermissions.jazztel.permite_ventas)">
                                    <ng-container *ngTemplateOutlet="contratacionesJazztel"></ng-container>
                                </div>
                                -->
                            </div>

                            <div class="mt-2 mb-5" *ngIf="thereIsCoverage === undefined">
                                <h5  class="tar-name-preload text-center">
                                    Consultando cobertura...
                                </h5>
                                <div class="d-flex justify-content-center">
                                    <img class="" src="./assets/img/spinner-simyo.svg" width="30" alt="Cargando...">
                                </div>
                            </div>

                            <div *ngIf="!clientIsCover && canContinueWithoutFiberCoverage() && !msgErrorPeticion">
                                <div
                                    class="alert alert-success-blue alert-list d-flex justify-content-between align-items-center"
                                    role="alert"
                                    *ngIf="thereIsCoverage === true && !wifi5gOfferAccepted">
                                    <div style="padding-bottom: 7px;">
                                        Hay <b>{{ fiberIndirectTechnologies.includes(order?.broadband?.access_type) ? 'cobertura de fibra indirecta' : 'cobertura de fibra' }}</b> para la dirección de instalación
                                        <img *ngIf="!enviroment.production" (click)="setUser()" src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="23">
                                    </div>
                                    <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                                <div
                                    class="alert alert-success-blue alert-list d-flex justify-content-between align-items-center"
                                    role="alert"
                                    *ngIf="wifi5gOfferAccepted">
                                    <div style="padding-bottom: 7px;">
                                        Continúa con la oferta <b>WiFi 5G</b> para esta dirección
                                    </div>
                                    <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                                <app-simyo-customer [pdv]="pdv" [formGroup]="customerFormGroup" [resultadoCobertura]="resultadoCobertura"></app-simyo-customer>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" *ngIf="!muestraNormalizacion && canContinueWithoutFiberCoverage() && clientIsCover && rate == null && showWithPortability()">
                        <app-simyo-rates [fibraRate]="fibraRateSpeed" [showTypeContent]="showTypeContent" [coberturaFormGroup]="coberturaFormGroup" [normalizadorFormGroup]="normalizadorFormGroup" (requestRemovePostpaidsLines)="removeAllAdditionalPostpaids($event)" (onChangeRate)="changeIsAdditionalIfNeed($event)" [resultadoCobertura]="resultadoCobertura"></app-simyo-rates>
                    </div>

                    <ng-container *ngIf="!muestraNormalizacion && canContinueWithoutFiberCoverage() && clientIsCover && rate  && showWithPortability()">
                        <ng-container *ngIf="typeOrder !== 'convergent'; then othersResult else othersResult"></ng-container>
                    </ng-container>

                </div>
            </div>
        </mat-step>

        <ng-container *ngIf="typeOrder !== orderType.BROADBAND">
            <mat-step  *ngFor="let mobilePackForm of movilPackForms.controls; let i = index "
                    [editable]="isEditable"
                    [stepControl]="mobilePackForm"
                    label="{{ (i + 1) + 'ª línea móvil' }}"
                    state="number">
                <app-simyo-customer *ngIf="!clientIsCover" [pdv]="pdv" [formGroup]="customerFormGroup" [resultadoCobertura]="resultadoCobertura"></app-simyo-customer>
                <app-simyo-movil-pack [resultadoCobertura]="resultadoCobertura" [index]="i" [formGroup]="mobilePackForm" [clienteFormGroup]="clienteFormGroup" [customerFormGroup]="customerFormGroup" [stepper]="stepper" [allBonos]="allBonos" (requestAddMobileLine)="addMobilePack()" (requestRemovePostpaidsLines)="removeAllAdditionalPostpaids($event)" (requestResetDocument)="requestResetDocument($event)" *ngIf="clientIsCover"></app-simyo-movil-pack>
            </mat-step>
        </ng-container>
        <mat-step [stepControl]="clienteFormGroup" [editable]="isEditable" label="Cliente" state="number">
            <ng-template matStepLabel>
                <div class="stepper-header-overlay" (click)="onClienteStepLabelClick($event)"></div>
                Cliente
            </ng-template>
            <app-simyo-user-data #tabUserData [formGroup]="clienteFormGroup" [stepper]="stepper" [typeOrder]="typeOrder"></app-simyo-user-data>
        </mat-step>

        <mat-step [editable]="isEditable" label="Confirmación" state="number">
            <ng-template matStepLabel>
                <div class="stepper-header-overlay" (click)="validateUserData()"></div>
                Confirmación
              </ng-template>
            <app-simyo-confirmation [pdv]="pdv" [stepper]="stepper" [orderCreateIsFinished]="orderCreateIsFinished" [movilPackForms]="movilPackForms" [clienteFormGroup]="clienteFormGroup" [fibraFormGroup]="fibraFormGroup" [signatureFormGroup]="signatureFormGroup" (onActivationRequest)="onActivationRequest($event)" (onActivationLoader)="activationLoader($event)"></app-simyo-confirmation>
        </mat-step>
    </mat-horizontal-stepper>
</ng-container>
<ng-container *ngIf="finished">
    <app-simyo-finished [orderLoader]="orderLoader" [signatureFormGroup]="signatureFormGroup"></app-simyo-finished>
</ng-container>


<!-- PLANTILLAS -->
<ng-template #errorSimyo>
    <div class="jumbotron-norm p-4">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'col-8': thereIsCoverage === null, 'col-12': thereIsCoverage === false}" [innerHTML]="msgErrorPeticion" style="align-self: center; font-size: 1.1rem;"></div>
                    <div class="col-4 d-flex justify-content-center" *ngIf="thereIsCoverage === null">
                        <div class="btn-group d-flex justify-content-center">
                            <button (click)="retryCheckCoverage()" class="btn btn-black--outline btn-sm">Comprobar cobertura</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- DF-498: plantilla Jazztel conservada comentada hasta reconfirmación PVR -->
<!--
<ng-template #contratacionesJazztel>
    <div class="jumbotron-norm p-4">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-3 d-flex justify-content-center" style="align-self: center;" >
                        <img src="./assets/img/jz-login-color.svg" class="img-fluid" width="200">
                    </div>
                    <div class="col-9">
                        <div class="card-body--digo">
                            <h5 class="mb-0">Lo sentimos, no tienes cobertura</h5>
                            <h5>de fibra a través de la red de Simyo, anímate e inténtalo en Jazztel.</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center" >
                <a href="https://pangea.orange.es" target="_blank" class="btn btn-black--outline mb-3">
                    Acceder a contrataciones {{ pdv?.info?.usuariopangea && pdv?.info?.usuariopangea !== '' ? '(' + pdv?.info?.usuariopangea + ')' : '' }}
                </a>
            </div>
        </div>
    </div>
</ng-template>
-->

<!-- No convergente -->
<ng-template #othersResult>
    <div class="col-lg-12 mt-3">
        <h5 class="title-step text-center" >
            <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
            Tarifa fibra
        </h5>
        <div class="card card-default card-horizontal mb-3">
            <div class="card-heading">
                <div class="row m-0 p-3">
                    <div class="col-lg p-0 align-self-center">
                        <h5 class="tar-name car-tar-1 m-0 pt-0 pe-3">
                            {{ (fiberIndirectTechnologies.includes(order?.broadband?.access_type) ? 'FIBRA IND ' : 'FIBRA ') + rate?.name }}
                            <!-- TODO: TEXTO MOCKEADO PONER LÓGICA DEL PLAN DE NETFLIX CONTRATADO SI APLICA -->
                            <ng-container *ngFor="let bono of order?.bonuses">
                                <ng-container *ngIf="bono.unified_price == 'broadband'">
                                    <span>+ {{ bono.name }} {{ bono.plan }}</span>
                                </ng-container>
                            </ng-container>
                        </h5>
                    </div>
                    <div class="col-lg-auto p-0 align-self-center">
                        <h5 class="tar-price car-tar-2 m-0">
                            {{ simyoService.calculatePriceWithBono(order?.bonuses, +rate?.rate_info?.price) | toFixedDecimals }}<span>€/mes</span></h5>
                    </div>
                </div>
            </div>
            <div class="card-body" style="vertical-align: middle;">
                <div class="row d-flex w-100 mx-0" style="gap: 20px;">
                    <div class="p-0 col align-self-center">
                        <h5 class="tar-name-5 m-0">
                            <b>INSTALACIÓN GRATIS</b>
                        </h5>
                        <h5 class="tar-name-5 m-0">
                            <b>ROUTER EN CESIÓN GRATIS</b>
                        </h5>
                        <!-- TODO: TEXTO MOCKEADO PONER LÓGICA DEL PLAN DE NETFLIX CONTRATADO SI APLICA -->
                        <ng-container *ngFor="let bono of order?.bonuses">
                            <ng-container *ngIf="bono.unified_price == 'broadband'">
                                <h5 class="tar-name-5 m-0"><b>{{ bono.name | uppercase }} {{ bono.plan | uppercase }}</b> </h5>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="p-0 m-0 col-md-auto btn-change align-self-center">
                        <a class="btn btn-simyo-a btn-sm" (click)="changeRate(orderType.BROADBAND)">Cambiar</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <br>
            <a (click)="next()" class="btn btn-simyo-o2 d-block w-100 mb-1 mt-4" role="button">
                Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
            </a>
            <br>
        </div>
    </div>
</ng-template>

<app-simyo-modal-portability #questionPortability (onAnswer)="nextPortability($event)" [typeOrder]="typeOrder"></app-simyo-modal-portability>
